export function concatItems<T>(container: T[], item: T[]) {
	return container.concat(item);
}
